import { Component, OnInit } from '@angular/core';
import { PermissaoService } from '../../../services/permissao/permissao.service';
import { ModuloPermissaoDashboard } from '../../../models/dashboard/modulo-permissao.model';

/** Janela de privilegio exigida por cada relatorio da tela (backend V1.126). */
const PERMISSAO_POR_RELATORIO: Record<string, keyof ModuloPermissaoDashboard> = {
  relatorioVendas: 'relatorioVendas',
  relatorioItensVendidos: 'relatorioItensVendidos',
  relatorioProdutos: 'relatorioListaItens',
  relatorioContasPagas: 'relatorioContasPagas',
  relatorioContasAPagar: 'relatorioContasAPagar',
  relatorioContasRecebidas: 'relatorioContasRecebidas',
  relatorioContasAReceber: 'relatorioContasAReceber',
  relatorioDRE: 'relatorioDre',
};

@Component({
  selector: 'app-relatorios',
  templateUrl: './relatorios.component.html',
  styleUrl: './relatorios.component.scss'
})
export class RelatoriosComponent implements OnInit {

  // Define qual relatório está selecionado
  selectedReport: string = 'relatorioVendas'; // Exibe Vendas por padrão

  constructor(private permissaoService: PermissaoService) { }

  ngOnInit(): void {
    // O padrão (Vendas) só serve para quem pode vê-lo: com uma janela por
    // relatório, a tela abre no primeiro que a pessoa tem direito de ver.
    if (!this.podeVer(this.selectedReport)) {
      const primeiroPermitido = Object.keys(PERMISSAO_POR_RELATORIO)
        .find(relatorio => this.podeVer(relatorio));
      this.selectedReport = primeiroPermitido ?? '';
    }
  }

  /** Se o usuário tem a janela do relatório — usado para esconder o item da lista. */
  podeVer(relatorio: string): boolean {
    const campo = PERMISSAO_POR_RELATORIO[relatorio];
    return campo ? this.permissaoService.temPermissao(campo) : false;
  }

  /** Extrato de caixa não é um dos filhos desta tela: leva para /lista-de-movimentos. */
  podeVerExtratoDeCaixa(): boolean {
    return this.permissaoService.temPermissao('extratoConta')
      || this.permissaoService.temPermissao('relatorioExtratoDeCaixa');
  }

  // Método para trocar de relatório ao clicar no item do accordion
  selectReport(reportName: string): void {
    this.selectedReport = reportName;
  }
}
